import { z } from "zod";

const phoneRegex = /^[\d\s+\-()]{9,20}$/;

export const contactFormSchema = z.object({
  name: z.string().min(2, "O nome deve ter pelo menos 2 caracteres").max(100, "O nome é demasiado longo"),
  email: z.string().email("Introduza um email válido").max(100, "O email é demasiado longo"),
  phone: z.string().regex(phoneRegex, "Introduza um telefone válido").optional().or(z.literal("")),
  message: z.string().min(10, "A mensagem deve ter pelo menos 10 caracteres").max(2000, "A mensagem é demasiado longa"),
});

export const proBonoFormSchema = contactFormSchema;

export const psicologiaFormSchema = contactFormSchema;

export const bookOrderFormSchema = z.object({
  name: z.string().min(2, "O nome deve ter pelo menos 2 caracteres").max(100),
  email: z.string().email("Introduza um email válido").max(100),
  phone: z.string().regex(phoneRegex, "Introduza um telefone válido").optional().or(z.literal("")),
  message: z.string().max(2000).optional().or(z.literal("")),
  dedication: z.string().max(500, "A dedicatória é demasiado longa").optional().or(z.literal("")),
});

export const notifyFormSchema = z.object({
  email: z.string().email("Introduza um email válido").max(100),
});

export const clientLoginSchema = z.object({
  email: z.string().email("Introduza um email válido").max(100),
  password: z.string().min(1, "A password é obrigatória").max(100),
});

export const adminLoginSchema = clientLoginSchema;

export type ContactFormData = z.infer<typeof contactFormSchema>;
export type ProBonoFormData = z.infer<typeof proBonoFormSchema>;
export type PsicologiaFormData = z.infer<typeof psicologiaFormSchema>;
export type BookOrderFormData = z.infer<typeof bookOrderFormSchema>;
export type NotifyFormData = z.infer<typeof notifyFormSchema>;
export type ClientLoginData = z.infer<typeof clientLoginSchema>;
export type AdminLoginData = z.infer<typeof adminLoginSchema>;

export function sanitizeInput(input: string): string {
  return input.trim().replace(/[<>]/g, "");
}

export function createFormData<T extends Record<string, string | undefined>>(
  data: T
): Record<string, string> {
  return Object.entries(data).reduce((acc, [key, value]) => {
    acc[key] = sanitizeInput(value ?? "");
    return acc;
  }, {} as Record<string, string>);
}
